import { useColorScheme } from "@mui/material/styles";

import { accent, font, neutral } from "./tokens";

/** 等宽字体：ID、IP、邮箱地址、密钥、日志等需要逐字符比对的内容用它。 */
export const mono = font.mono;

/**
 * 图表配色只有两种用途：
 * - 单一系列（数量、趋势）：强调色，明暗模式各取对比度足够的一阶；
 * - 好坏状态：用主题 palette 的 success / warning / error，且总和文字标签一起出现。
 * 全站没有分类色板——没有哪张图需要靠颜色区分多个并列系列。
 */
export const seriesColor = (mode: "light" | "dark"): string => (mode === "dark" ? accent[300] : accent[500]);
export const mutedColor = (mode: "light" | "dark"): string => (mode === "dark" ? neutral[700] : neutral[200]);

/** 当前实际生效的明暗模式（"跟随系统"时取系统值）。只接受字符串颜色的图表用它取色。 */
export function useChartMode(): "light" | "dark" {
  const { mode, systemMode } = useColorScheme();
  return (mode === "system" ? systemMode : mode) === "dark" ? "dark" : "light";
}
